// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { Modal } from 'components/atoms/Modal';
import { useTranslation } from 'react-i18next';
import QRScanning, {
  QRScanGroupItem,
  QRScanningProps,
} from 'components/organisms/QRScanning';
import styles from './index.module.scss';

export type QRScanningModalProps<
  TScanResult,
  TGroupItem extends QRScanGroupItem
> = QRScanningProps<TScanResult, TGroupItem>;

function QRScanningModal<TScanResult, TGroupItem extends QRScanGroupItem>({
  title,
  finishText,
  ...qrScanningProps
}: QRScanningModalProps<TScanResult, TGroupItem>) {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.qrScanningModal}
      contentClassName={styles.container}
      centered
    >
      <QRScanning
        {...qrScanningProps}
        title={title ?? (t('qr_scanning_modal.title') as string)}
        finishText={
          finishText ?? (t('qr_scanning_modal.finish_scanning') as string)
        }
      />
    </Modal>
  );
}

export default QRScanningModal;
